module.exports = __webpack_public_path__ + "02_bob_gray.096da63c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/02_bob_gray.png
// module id = Rsf0
// module chunks = 0